import {domReady} from './Functions/DomReady';
import {initMemberNumberRequired} from './Functions/RequiredCourseForm';

domReady(() => {
  initMemberNumberRequired();
  let submenuToggles = document.querySelectorAll('.js-toggleSubmenu');
  Array.prototype.forEach.call(submenuToggles, (submenuToggle) => {
    submenuToggle.addEventListener('click', (event) => {
      const menuItem = event.target.parentElement?.parentElement;
      if (menuItem instanceof HTMLElement && menuItem.classList.contains('js-menuItem')) {
        menuItem.classList.toggle('menu__listItem--open');
      }
    });
  });
});

const reloadButton = document.querySelector('.js-captchaReloadButton')!;
reloadButton.addEventListener('click', () => {
  requestNewCaptcha(reloadButton);
});

async function requestNewCaptcha(button) {
  let response = await fetch(button.dataset.url);
  const oldCaptcha = document.querySelector('.js-captchaContainer img');
  if (!response.ok || !oldCaptcha) {
    return;
  } else {
    const parent = oldCaptcha.parentNode;
    const html: string = await response.text();
    let element = document.createElement('html');
    element.innerHTML = html;
    const newCaptcha = element.querySelector('.js-captchaContainer img');
    if (oldCaptcha && newCaptcha) {
      parent!.removeChild(oldCaptcha);
      parent!.appendChild(newCaptcha);
    }
  }
}
